import { render, staticRenderFns } from "./ProfileCarousel.vue?vue&type=template&id=f44312ae&scoped=true"
import script from "./ProfileCarousel.vue?vue&type=script&lang=js"
export * from "./ProfileCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProfileCarousel.vue?vue&type=style&index=0&id=f44312ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44312ae",
  null
  
)

export default component.exports